import type { Optional } from '@asseco/react-native-gov-components';
import type { PeticePeticeDto } from '@gov-nx/api';
import { useDownloadEvents } from '@gov-nx/core/events';
import { useLocale } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { MB } from '../File/constants';

type EPetitionPetitionersAttachment = {
	name: string;
	size: number;
	downloadLabel: string;
	onDownload: (onSuccess: () => void) => void;
};

interface PetitionPetitionersAttachmentsProps {
	petitionId: number;
	petition: Optional<PeticePeticeDto>;
	code: PageCode;
}

export const usePetitionPetitionersAttachments = ({
	petitionId,
	petition,
	code,
}: PetitionPetitionersAttachmentsProps) => {
	const { downloadEPetitionPetitioners } = useDownloadEvents();
	const { t } = useLocale(code);

	const attachments: EPetitionPetitionersAttachment[] = [
		{
			name: t('prilohy.epetice.seznamPetentu-pdf'),
			size: 1.68 * MB,
			downloadLabel: t('prilohy.akce.stahnout'),
			onDownload: (onSuccess) =>
				downloadEPetitionPetitioners({
					petitionId,
					format: 'PDF',
					callback: onSuccess,
				}),
		},
		{
			name: t('prilohy.epetice.seznamPetentu-xls'),
			size: 1.68 * MB,
			downloadLabel: t('prilohy.akce.stahnout'),
			onDownload: (onSuccess) =>
				downloadEPetitionPetitioners({
					petitionId,
					format: 'XLSX',
					callback: onSuccess,
				}),
		},
	];

	return {
		attachments,
		isVisible: petition?.mnouZalozene ?? false,
		strings: { heading: t('nadpis.epetice.popis') },
	};
};
